import {
  Component,
  Input,
  Output,
  EventEmitter,
  inject,
  OnInit,
  HostListener,
  ElementRef,
} from '@angular/core';
import { UserService } from '@app/auth/services/user.service';
import { MessageService } from 'primeng/api';
import { ComentarioService } from '../api/services/comentario.service';
import {
  ReactiveFormsModule,
  FormGroup,
  FormBuilder,
  Validators,
} from '@angular/forms';
import { Textarea } from 'primeng/textarea';
import { CommonModule } from '@angular/common';
import { Avatar } from 'primeng/avatar';
import { CurtidaService } from '../api/services/curtida.service';
import { Router } from '@angular/router';
import { AuthService } from '@app/auth/services/auth.service';

@Component({
  selector: 'app-reactions',
  standalone: true,
  imports: [ReactiveFormsModule, Textarea, CommonModule, Avatar],
  providers: [ComentarioService],
  templateUrl: './reactions.component.html',
  styleUrl: './reactions.component.scss',
})
export class ReactionsComponent implements OnInit {
  private readonly messageService = inject(MessageService);
  private readonly userService = inject(UserService);
  private readonly curtidaService = inject(CurtidaService);
  private readonly comentarioService = inject(ComentarioService);
  private readonly router = inject(Router);
  private readonly authService = inject(AuthService);
  private readonly fb = inject(FormBuilder);
  private readonly elementRef = inject(ElementRef);

  formComment!: FormGroup;
  userID: any;
  initials: any;
  IsAuthenticad: boolean = false;
  isSubmitting: boolean = false;
  @Input() campanhaID!: string;
  @Input() curtidaID!: number;
  @Input() totalCurtidas: number = 0;
  @Input() totalComentarios: number = 0;
  @Input() campanhaTitulo: string = '';
  @Output() commentAdded = new EventEmitter<any>();
  @Input() showComment: boolean = false;
  @Output() showCommentChange = new EventEmitter<boolean>();
  @Output() commentClicked = new EventEmitter<void>();
  isSaved: boolean = false;

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent): void {
    if (
      this.showComment &&
      !this.elementRef.nativeElement.contains(event.target)
    ) {
      this.showComment = false;
      this.showCommentChange.emit(this.showComment);
    }
  }

  @HostListener('document:keydown.escape')
  onEscapePress(): void {
    if (this.showComment) {
      this.showComment = false;
      this.showCommentChange.emit(this.showComment);
    }
  }

  isLiked(): boolean {
    if (!this.userID) return false;
    const cId = Number(this.campanhaID);
    if (!cId) return false;
    return this.curtidaService.isCampanhaLiked(cId);
  }

  ngOnInit(): void {
    this.authService.isAuthenticatedChange().subscribe((isAuth) => {
      this.IsAuthenticad = isAuth;
      this.userID = this.userService.getUserId();
      if (isAuth && this.userID) {
        this.curtidaService.loadUserLikes(this.userID).subscribe();
      }
    });
    this.userID = this.userService.getUserId();
    this.IsAuthenticad = Boolean(this.userID);
    this.initials = this.userService.getUserInitials();
    this.checkSaved();

    const cId = Number(this.campanhaID);
    if (this.curtidaID) {
      this.curtidaService.recordLike(cId, this.curtidaID);
    } else if (cId && this.curtidaService.isCampanhaLiked(cId)) {
      this.curtidaID = this.curtidaService.getCurtidaId(cId)!;
    }

    if (this.userID) {
      this.curtidaService.loadUserLikes(this.userID).subscribe();
    }

    this.curtidaService.userLikes$.subscribe((likes) => {
      if (cId && likes.has(cId)) {
        this.curtidaID = likes.get(cId)!;
      } else if (cId && !this.curtidaService.isCampanhaLiked(cId)) {
        this.curtidaID = undefined as any;
      }
    });

    this.formComment = this.fb.group({
      conteudo: ['', [Validators.required, Validators.maxLength(500)]],
    });
  }

  checkSaved(): void {
    try {
      const saved = JSON.parse(
        localStorage.getItem('fundcube_saved_campaigns') || '[]',
      );
      this.isSaved = Array.isArray(saved) && saved.includes(this.campanhaID);
    } catch {
      this.isSaved = false;
    }
  }

  toggleSave(event: Event): void {
    event.stopPropagation();
    try {
      let saved = JSON.parse(
        localStorage.getItem('fundcube_saved_campaigns') || '[]',
      );
      if (!Array.isArray(saved)) saved = [];

      if (this.isSaved) {
        saved = saved.filter((id: any) => id !== this.campanhaID);
        this.isSaved = false;
        this.messageService.add({
          severity: 'info',
          summary: 'Campanha removida',
          detail: 'Campanha removida dos seus itens guardados.',
          life: 2500,
        });
      } else {
        saved.push(this.campanhaID);
        this.isSaved = true;
        this.messageService.add({
          severity: 'success',
          summary: 'Campanha guardada',
          detail: 'Campanha guardada nos seus favoritos!',
          life: 2500,
        });
      }
      localStorage.setItem('fundcube_saved_campaigns', JSON.stringify(saved));
    } catch (e) {
      console.error(e);
    }
  }

  shareCard(event: Event): void {
    event.stopPropagation();
    const url = `${window.location.origin}/detalhe-campanha/${this.campanhaID}`;
    if (navigator.share) {
      navigator
        .share({
          title: this.campanhaTitulo || 'FundCube - Apoie esta campanha',
          text: 'Apoie este projecto incrível na plataforma FundCube!',
          url: url,
        })
        .catch(() => {});
    } else {
      navigator.clipboard.writeText(url).then(() => {
        this.messageService.add({
          severity: 'success',
          summary: 'Link copiado!',
          detail:
            'O link da campanha foi copiado para a área de transferência.',
          life: 3000,
        });
      });
    }
  }

  commentCampanha(event: Event) {
    event.stopPropagation();
    if (this.IsAuthenticad) {
      this.showComment = true;
      this.showCommentChange.emit(this.showComment);
      this.commentClicked.emit();
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Login necessário',
        detail: 'Faça login para comentar campanhas',
        life: 5000,
      });
      setTimeout(() => {
        this.openLogin();
      }, 0);
      return;
    }
  }

  closeComment(event?: Event) {
    if (event) {
      event.stopPropagation();
    }
    this.showComment = false;
    this.showCommentChange.emit(this.showComment);
  }

  onEnterPress(event: KeyboardEvent) {
    if (event.key === 'Enter' && !event.shiftKey) {
      event.preventDefault();
      if (
        !this.isSubmitting &&
        this.formComment.valid &&
        this.formComment.get('conteudo')?.value?.trim()
      ) {
        this.submitComment();
      }
    }
  }

  submitComment() {
    const conteudo = this.formComment.get('conteudo')?.value?.trim();
    if (!conteudo || this.isSubmitting) {
      return;
    }

    this.isSubmitting = true;
    const params = {
      Id: 0,
      utilizadorID: this.userID,
      campanhaID: this.campanhaID,
      conteudo: conteudo,
    };

    this.comentarioService.store(params).subscribe({
      next: (result: any) => {
        this.isSubmitting = false;
        if (result.retorno.codigo === 200) {
          this.totalComentarios = (this.totalComentarios || 0) + 1;
          this.formComment.reset();
          this.showComment = false;
          this.showCommentChange.emit(this.showComment);
          this.messageService.add({
            severity: 'success',
            summary: 'Sucesso',
            detail: 'Comentário publicado com sucesso!',
            life: 3000,
          });
          this.commentAdded.emit({
            campanhaID: this.campanhaID,
            comment: result?.data,
          });
        }
      },
      error: (error: any) => {
        this.isSubmitting = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Operação não permitida',
          detail:
            error?.error?.retorno?.mensagem ||
            'Não é possível comentar nesta campanha porque já foi encerrada.',
          life: 5000,
        });
        console.error(error);
      },
    });
  }

  togglikes(event: Event) {
    event.stopPropagation();
    if (!this.IsAuthenticad || !this.userID) {
      this.openLogin(this.router.url);
      return;
    }

    const cId = Number(this.campanhaID);
    const currentlyLiked = this.isLiked();

    if (currentlyLiked) {
      const curtidaParaDeletar =
        this.curtidaID || this.curtidaService.getCurtidaId(cId);
      this.curtidaID = undefined as any;
      if (cId) {
        this.curtidaService.removeLike(cId);
      }
      this.totalCurtidas = Math.max(0, (this.totalCurtidas || 1) - 1);

      if (curtidaParaDeletar) {
        this.curtidaService.delete(curtidaParaDeletar).subscribe({
          next: () => {
            this.messageService.add({
              severity: 'info',
              summary: 'Gosto removido',
              detail: 'O seu gosto foi removido desta campanha.',
              life: 2000,
            });
          },
          error: (error: any) => {
            console.error('Erro ao remover curtida:', error);
          },
        });
      } else if (cId && this.userID) {
        this.curtidaService.loadUserLikes(this.userID).subscribe((likes) => {
          const foundId = likes.get(cId);
          if (foundId) {
            this.curtidaService.delete(foundId).subscribe({
              next: () => {
                this.curtidaService.removeLike(cId);
              },
              error: (err) => console.error('Erro ao remover curtida:', err),
            });
          }
        });
      }
      this.messageService.add({
        severity: 'info',
        summary: 'Gosto removido',
        detail: 'O seu gosto foi removido desta campanha.',
        life: 2000,
      });
    } else {
      this.totalCurtidas = (this.totalCurtidas || 0) + 1;
      const params = {
        id: 0,
        campanhaID: cId,
        utilizadorID: this.userID,
      };

      this.curtidaService.store(params).subscribe({
        next: (result: any) => {
          const newId = result?.data?.id ?? result?.data;
          if (newId) {
            const numId = Number(newId);
            this.curtidaID = numId;
            if (cId) {
              this.curtidaService.recordLike(cId, numId);
            }
          }
          this.messageService.add({
            severity: 'success',
            summary: 'Gosto registado',
            detail: 'Gostou desta campanha!',
            life: 2000,
          });
        },
        error: (error: any) => {
          if (error?.status === 409 || error?.error?.retorno?.codigo === 409) {
            this.curtidaService
              .loadUserLikes(this.userID)
              .subscribe((likes) => {
                const foundId = likes.get(cId);
                if (foundId) {
                  this.curtidaID = foundId;
                  this.curtidaService.recordLike(cId, foundId);
                }
              });
          } else {
            this.totalCurtidas = Math.max(0, (this.totalCurtidas || 1) - 1);
            this.messageService.add({
              severity: 'error',
              summary: 'Operação não permitida',
              detail:
                error?.error?.retorno?.mensagem ||
                'Não é possível curtir esta campanha.',
              life: 4000,
            });
            console.error(error);
          }
        },
      });
    }
  }

  isInvalid(field: string): boolean {
    const control = this.formComment.get(field);
    return !!(control && control.invalid && (control.dirty || control.touched));
  }

  openLogin(returnUrl?: string): void {
    if (returnUrl) {
      this.router.navigate(['/auth/login'], { queryParams: { returnUrl } });
    } else {
      this.router.navigate(['/auth/login']);
    }
  }
}
